import { z } from "zod";
import { objectIdSchema, optionalIdSchema } from "./common.js";
/**
 * Date windows are IST calendar days: "7d" is today plus the six days before
 * it, "today" starts at midnight in India whatever the server's clock says.
 * "custom" uses `from`/`to` (inclusive YYYY-MM-DD, IST).
 */
export const PERFORMANCE_RANGES = ["today", "7d", "30d", "90d", "all", "custom"];
const isoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Use a YYYY-MM-DD date.");
export const performanceQuerySchema = z
    .object({
    range: z.enum(PERFORMANCE_RANGES).default("all"),
    from: isoDay.optional(),
    to: isoDay.optional(),
    // Checked as ids, so a mangled link is a 400 rather than a failed database cast.
    productId: optionalIdSchema,
    counterId: optionalIdSchema,
    khatiId: optionalIdSchema,
    networkMemberId: optionalIdSchema,
    q: z.string().optional(),
    metric: z.enum(["scans", "points"]).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
})
    .refine((q) => q.range !== "custom" || (q.from && q.to && q.from <= q.to), {
    message: "Choose a start date on or before the end date.",
    path: ["from"],
});
/** Organization-scoped roster drilldown for a network member and their counters. */
export const performanceNetworkScopeQuerySchema = z.object({
    networkMemberId: objectIdSchema,
    counterId: optionalIdSchema,
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=performance.js.map